import { render, staticRenderFns } from "./install.vue?vue&type=template&id=18e6fe2e&"
import script from "./install.vue?vue&type=script&lang=ts&"
export * from "./install.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports